import { FC } from 'react';
import { PolicyFixInput } from '../../../../types/issues-types';
import RadioInput from './Radio';
import Select from './Select';

const InputResolver: FC<React.PropsWithChildren<InputResolverProps>> = ({
  input,
  onChange,
}) => {
  const { type, ...otherProps } = input;
  switch (type) {
    case 'radio':
      return <RadioInput type={type} {...otherProps} onChange={onChange} />;
    case 'select':
      return <Select type={type} {...otherProps} onChange={onChange} />;
    default:
      return null;
  }
};

export interface InputResolverProps {
  input: PolicyFixInput;
  onChange: (type: string, input: string | string[]) => void;
}

export default InputResolver;
